import { useEffect, useMemo, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'src/app/components/PDFViewer/pdf-viewer.scss';

import { debounce } from 'lodash';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import { FiZoomIn, FiZoomOut } from 'react-icons/fi';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString();

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

const maxWidth = 800;

type PDFFile = string | File | null;

interface IPDFViewerProps {
  file: PDFFile;
  // width?: number;
}
const PDFViewer: React.FC<IPDFViewerProps> = ({ file }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);

  const [containerWidth, setContainerWidth] = useState<number>(0);

  const debouncedSetWidth = useMemo(
    () =>
      debounce((width: number) => {
        setContainerWidth(width);
      }, 200),
    [],
  );

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const newWidth = entries[0].contentRect.width;
      setContainerWidth((prev) => {
        if (newWidth < prev) {
          debouncedSetWidth.cancel();
          return newWidth;
        }

        debouncedSetWidth(newWidth);
        return prev;
      });
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  const changePage = (offset: number) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
    // handleScrollToPage();
  };

  const nextPage = () => {
    changePage(1);
    // handleScrollToPage();
  };

  // const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  // const [containerWidth, setContainerWidth] = useState<number>();

  // const onResize = useCallback<ResizeObserverCallback>((entries) => {
  //   const [entry] = entries;

  //   if (entry) {
  //     setContainerWidth(entry.contentRect.width);
  //   }
  // }, []);

  // useResizeObserver(containerRef, resizeObserverOptions, onResize);

  const onDocumentLoadSuccess = ({ numPages: pages }: PDFDocumentProxy): void => {
    setNumPages(pages);
  };

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.6));

  // const handleScrollToPage = () => {
  //   const pageElement = document.getElementById(`page_${pageNumber}`);
  //   if (pageElement) {
  //     pageElement.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };
  return (
    <div className="pdf-container" ref={containerRef}>
      <div className="zoom-container">
        <button onClick={zoomOut} type="button" className="zoom-btn">
          <FiZoomOut size={12} color="#343a40" />
        </button>
        <span style={{ fontWeight: '500', fontSize: '12px', color: 'var(--primary_text_color)' }}>
          {Math.round(scale * 100)}%
        </span>
        <button onClick={zoomIn} type="button" className="zoom-btn">
          <FiZoomIn size={12} color="#343a40" />
        </button>
      </div>
      {containerWidth ? (
        <Document loading={null} file={file} onLoadSuccess={onDocumentLoadSuccess} options={options}>
          {/* {Array.from(new Array(numPages), (_el, index) => (
          <div key={`page_${index + 1}`} id={`page_${index + 1}`}>
            <Page
              loading={null}
              pageNumber={index + 1}
              // width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
              width={width || maxWidth}
            />
          </div>
        ))} */}
          <Page scale={scale} loading={null} pageNumber={pageNumber} width={containerWidth - 10} />
        </Document>
      ) : null}

      {numPages ? (
        <div className="page-controls">
          <button
            style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
            type="button"
            disabled={pageNumber <= 1}
            onClick={previousPage}
          >
            {'<'}
          </button>
          <span>
            {pageNumber} of {numPages}
          </span>
          <button
            style={{ cursor: pageNumber >= numPages ? 'not-allowed' : 'pointer' }}
            type="button"
            disabled={pageNumber >= numPages}
            onClick={nextPage}
          >
            {'>'}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default PDFViewer;
